import { AlertTriangle, CheckCircle, KeyRound } from 'lucide-react';

import { CollaboratorCreationResult } from './collaboratorTypes';

interface CollaboratorsRecapModalProps {
  results: CollaboratorCreationResult[];
}

/**
 * Récapitulatif affiché après la création : mots de passe temporaires à
 * transmettre manuellement (ils ne seront plus jamais affichés) et échecs
 * éventuels (rattrapables dans la fiche PM → Collaborateurs).
 */
export const CollaboratorsRecapModal: React.FC<CollaboratorsRecapModalProps> = ({ results }) => {
  const failures = results.filter((r) => !r.success);

  return (
    <div className="p-8 max-w-3xl">
      <h2 className="text-xl font-semibold text-gray-900 mb-1 flex items-center gap-2">
        <KeyRound className="text-primary" size={20} />
        Comptes collaborateurs créés
      </h2>
      <p className="text-sm text-gray-500 mb-5">
        Transmettez ces mots de passe temporaires — ils ne seront plus affichés.
      </p>

      <div className="rounded-xl border border-gray-200 divide-y divide-gray-100">
        {results.map((result) => (
          <div key={result.email} className="flex items-center gap-3 p-3">
            {result.success ? (
              <CheckCircle className="text-green-500 flex-shrink-0" size={18} />
            ) : (
              <AlertTriangle className="text-red-500 flex-shrink-0" size={18} />
            )}
            <div className="flex flex-col min-w-0 flex-1">
              <span className="text-sm font-medium text-gray-900 truncate">
                {result.firstName} {result.lastName}
              </span>
              <span className="text-xs text-gray-500 truncate">{result.email}</span>
            </div>
            {result.success ? (
              <code className="rounded bg-gray-100 px-3 py-1.5 text-sm font-mono select-all">
                {result.temporaryPassword}
              </code>
            ) : (
              <span className="text-xs text-red-600 max-w-[45%]">{result.error}</span>
            )}
          </div>
        ))}
      </div>

      {failures.length > 0 && (
        <p className="mt-4 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3">
          {failures.length} compte(s) n&apos;ont pas pu être créés — vous pouvez
          les ajouter depuis la fiche de la personne morale, section Collaborateurs.
        </p>
      )}
    </div>
  );
};
